import {
	IonGrid,
	IonRow,
	IonCol,
	IonButtons,
	IonButton,
	IonCardTitle,
	IonCardSubtitle,
} from "@ionic/react";
import React from "react";
import { useHistory } from "react-router";
import Spacer from "../../../../components/spacer";
import user from "../../../../services/users/reducer";
import DownloadData from "../UserDataTable/DownloadData";

interface props {
	user: any;
	isAdmin: any;
}

const UserHeader: React.FC<props> = ({ user, isAdmin }) => {
	const history = useHistory();

	return (
		<IonGrid>
			<IonRow>
				{user.id && (
					<IonCol>
						<IonCardTitle>{user.displayName}</IonCardTitle>
						{user.study && (
							<IonCardSubtitle className="header-study">
								{user.study}
							</IonCardSubtitle>
						)}
						<Spacer size="15" />
						{isAdmin && user.role === "participant" && (
							<IonButtons>
								<IonButton onClick={() => history.push(`/users/${user.id}`)}>
									Calendar
								</IonButton>
								<IonButton
									onClick={() => history.push(`/users/${user.id}/charts`)}
								>
									Charts
								</IonButton>
								<DownloadData id={user.id} />
								{/* <IonButton
									onClick={() => history.push(`/users/${user.id}/data`)}
								>
									Data
								</IonButton> */}
								<IonButton
									onClick={() => history.push(`/users/${user.id}/config`)}
								>
									Config
								</IonButton>
							</IonButtons>
						)}
						<Spacer size="60" />
					</IonCol>
				)}
			</IonRow>
		</IonGrid>
	);
};

export default UserHeader;
